import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Text from '../Text/Text'
import Button from '../Button/Button'
import styles from './feedbackLayout.module.scss'

const FeedbackLayout = (props) => {
  const {
    title,
    subTitle,
    image,
    primaryAction,
    primaryLabelAction,
    secondaryAction,
    secondaryLabelAction,
    note,
    Ilustration,
    center
  } = props

  const layoutClass = classNames(styles.layout, {
    [styles.center]: center
  })

  return (
    <div className={layoutClass}>
      {image && <img src={image} alt={title} />}
      {Ilustration && <Ilustration />}

      {title && (
        <Text
          size="lg"
          color="gray"
          variation="dark"
          margin="20px 0px 0"
          value={title}
          extraBold
        />
      )}

      {subTitle && (
        <Text size="xs" color="gray" margin="16px 0 0" value={subTitle} />
      )}

      <div style={{ display: 'flex', alignItems: 'center' }}>
        {primaryAction && primaryLabelAction && (
          <Button
            type="outlined_dark"
            margin="24px 24px 0px 0px"
            width="163px"
            height="48px"
            onClick={primaryAction}
          >
            <Text
              font="custom"
              color="gray"
              size="xs"
              value={primaryLabelAction}
              bold
            />
          </Button>
        )}

        {secondaryAction && secondaryLabelAction && (
          <Button
            type="secondary"
            margin="24px 0px 0px 0px"
            width="163px"
            onClick={secondaryAction}
            height="48px"
          >
            <Text
              font="custom"
              color="white"
              size="xs"
              value={secondaryLabelAction}
              bold
            />
          </Button>
        )}
      </div>

      {note && <Text size="xs" color="gray" margin="16px 0 0" value={note} />}
    </div>
  )
}

FeedbackLayout.defaultProps = {
  title: null,
  subTitle: null,
  image: null,
  primaryAction: null,
  primaryLabelAction: null,
  secondaryAction: null,
  secondaryLabelAction: null,
  note: null,
  Ilustration: null,
  center: false
}

FeedbackLayout.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  image: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryLabelAction: PropTypes.string,
  secondaryAction: PropTypes.func,
  secondaryLabelAction: PropTypes.string,
  note: PropTypes.string,
  Ilustration: PropTypes.any,
  center: PropTypes.bool
}

export default FeedbackLayout
